import React from "react";
import "./denting.css";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
export default function DentingPainting() {
  return (
    <>
    <Helmet>
      <title>Car Denting & Painting Service in Palwal | AutoCare</title>
      <meta
        name="description"
        content="Need car denting and painting in Palwal? AutoCare offers expert dent removal, scratch repair, repainting, and body panel replacement with perfect color matching."
      />
      <link
        rel="canonical"
        href="https://car-repair-mechanic-palwal.netlify.app/services/denting-painting"
      />
    </Helmet>
    <section className="servicePage">
      <div className="serviceContent">
        
        {/* TEXT SECTION */}
        <div className="textContent">
          <h1>Car Denting & Painting Service in Palwal</h1>

          <p>
            Scratches, dents, or accident damage can ruin your car’s look.
            At <strong>AutoCare</strong>, we provide professional
            <span className="highlight"> car denting & painting services</span>
            with precision, quality paints, and expert technicians.
            Trusted <strong>Auto Care in Palwal</strong> for reliable
            <span className="highlight"> car repair</span>.
          </p>

          <h2>What is Denting & Painting?</h2>
          <p>
            Denting & painting is a specialized <span className="highlight">
            car body repair</span> process that removes dents, fixes damaged panels,
            and restores your vehicle’s original paint finish.
            Our advanced tools ensure factory-like results.
          </p>

          <h2>Our Denting & Painting Services Include</h2>
          <ul>
            <li>Minor & major dent removal</li>
            <li>Accidental body repair</li>
            <li>Scratch removal & repainting</li>
            <li>Panel replacement & alignment</li>
            <li>Color matching & full body paint</li>
          </ul>

          <h2>Why Choose AutoCare for Denting & Painting?</h2>
          <ul>
            <li>Experienced technicians & modern equipment</li>
            <li>High-quality paints with long-lasting finish</li>
            <li>Affordable and transparent pricing</li>
            <li>Trusted <span className="highlight">Auto Care in Palwal</span></li>
            <li>Complete <span className="highlight">car repair</span> solution under one roof</li>
          </ul>

          <h2>Book Denting & Painting Service Today</h2>
          <p>
            Looking for professional <span className="highlight">
            car denting & painting near me</span>?
            Choose <strong>AutoCare</strong> for reliable results and perfect finishing.
          </p>

          <button className="primaryBtn">
            <Link to="/contact">  
            Book Denting & Painting Service
            </Link>
          </button>
        </div>

        {/* IMAGE SECTION */}
        <div className="imageContent">
          <img
            src="/carServiceImages/dentingpainting.webp"
            alt="Car Denting and Painting Service in Palwal"
          />
        </div>
      </div>
    </section>
    </>
  );
}
